import axios from '@/plugins/axios'

import { useAuthorizationStore } from '@/store/authorizationStore'

const getWorkspaceId = () => useAuthorizationStore().getWorkspaceSlug
const getAccountId = () => useAuthorizationStore().getAccountSlug

const createInvitationsForWorkspace = (formData) => axios.post(`${getAccountId()}/invitations/user`, formData)
const resendInvitationForWorkspace = (slug) => axios.post(`${getAccountId()}/invitations/user/${slug}`)
const updateInvitationForWorkspace = ({ slug, formData }) => axios.patch(`${getAccountId()}/invitations/user/${slug}`, formData)
const deleteInvitationForWorkspace = (slug) => axios.delete(`${getAccountId()}/invitations/user/${slug}`)

const createInvitationsForVendor = (formData) => axios.post(`${getWorkspaceId()}/invitations/vendor`, formData)
const createInvitationsForBuyer = (formData) => axios.post(`${getWorkspaceId()}/invitations/buyer`, formData)

const resendInvitationForVendor = (slug) => axios.post(`${getWorkspaceId()}/invitations/vendor/${slug}`)
const resendInvitationForBuyer = (slug) => axios.post(`${getWorkspaceId()}/invitations/buyer/${slug}`)

const deleteInvitationForVendor = (slug) => axios.delete(`${getWorkspaceId()}/invitations/vendor/${slug}`)

const deleteInvitationForBuyer = (slug) => axios.delete(`${getWorkspaceId()}/invitations/buyer/${slug}`)

const checkInvitation = (slug) => axios.get(`invitations/${slug}`)
const registerInvitation = ({ slug, formData }) => axios.post(`invitations/${slug}`, formData)

export {
    createInvitationsForWorkspace,
    createInvitationsForVendor,
    createInvitationsForBuyer,
    resendInvitationForVendor,
    resendInvitationForBuyer,
    deleteInvitationForVendor,
    deleteInvitationForBuyer,
    resendInvitationForWorkspace,
    updateInvitationForWorkspace,
    deleteInvitationForWorkspace,
    checkInvitation,
    registerInvitation,
}
